import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { seleccionarDisponibilidadScienza } from '../../../actions/empadronamiento/Empadronamiento';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { EMPADRONAMIENTO_MENU_PERMISOS, MEDICACION_MENU_PERMISOS } from '../../../utils/permisos';
import { CheckCircleIcon } from '@material-ui/data-grid';

export const ModalDisponibilidadMedicamentosScienza = ({ open, onClose, dataMedic = [], esEmpadronamiento,
  seleccionarDisabled = false }) => {
  const dispatch = useDispatch();

  const { disponibilidadMedicamentosScienza } = useSelector((state) => state.empadronamiento);
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const esAuditorOspe = validarSoloUnPermiso(
    permisosUser,
    esEmpadronamiento ? EMPADRONAMIENTO_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA : MEDICACION_MENU_PERMISOS.BANDEJA_SOLICITUD_AUDITORIA
  );

  const disabledProp = seleccionarDisabled || !esAuditorOspe;

  const seleccionarDisponibilidad = (medicamento) => {
    dispatch(seleccionarDisponibilidadScienza(
      esEmpadronamiento ? null : dataMedic.idItem,
      esEmpadronamiento ? dataMedic.idItem : null,
      medicamento.idProducto,
      medicamento.cantidad,
      medicamento.precio,
      medicamento.descuento,
      medicamento.pvp,
      medicamento.idAlfabeta,
      medicamento.troquel,
      medicamento.forma,
      medicamento.laboratorio,
      medicamento.nombre,
      medicamento.idMonodroga
    ));
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xl" fullWidth>
      <DialogTitle>Disponibilidad de Medicamentos</DialogTitle>
      <DialogContent dividers>
        <TableContainer component={Paper} style={{ overflowX: "auto", maxWidth: "80%", margin: "0 auto" }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Monodroga</TableCell>
                <TableCell>Presentación</TableCell>
                <TableCell>Medicamento</TableCell>
                <TableCell>Cantidad</TableCell>
                {/*<TableCell>Desde</TableCell>*/}
                {/*<TableCell>Hasta</TableCell>*/}
                <TableCell>SURGE</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow >
                <TableCell>{dataMedic.medicamento?.drogas}</TableCell>
                <TableCell>{dataMedic.medicamento?.presentacion}</TableCell>
                <TableCell>{dataMedic.medicamento?.nombre}</TableCell>
                <TableCell>{dataMedic.cantidad}</TableCell>
                {/*<TableCell>{dataMedic.desde}</TableCell>*/}
                {/*<TableCell>{dataMedic.hasta}</TableCell>*/}
                <TableCell>{dataMedic.sur === true ? "SI" : "NO"}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        <TableContainer component={Paper} style={{ marginTop: '2rem' }}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Medicamento</TableCell>
                <TableCell>Disponibilidad</TableCell>
                <TableCell>Presentación</TableCell>
                <TableCell>Acción Terapéutica</TableCell>
                <TableCell>Precio</TableCell>
                <TableCell>Drogas</TableCell>
                <TableCell>Laboratorio</TableCell>
                <TableCell>SURGE</TableCell>
                <TableCell>Observaciones Scienza</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {disponibilidadMedicamentosScienza && disponibilidadMedicamentosScienza?.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{dataMedic.troquelSeleccionadoSC === parseInt(row.troquel) ? <CheckCircleIcon style={{ color: 'green' }} /> : ""}</TableCell>
                  <TableCell>{row.nombre}</TableCell>
                  <TableCell>{row.cantidad}</TableCell>
                  <TableCell>{row.forma}</TableCell>
                  <TableCell>{row.tratamiento}</TableCell>
                  <TableCell>{row.precio}</TableCell>
                  <TableCell>{row.monodroga}</TableCell>
                  <TableCell>{row.laboratorio}</TableCell>
                  <TableCell>{row.sur}</TableCell>
                  <TableCell>{row.observacionesScienza}</TableCell>
                  <TableCell>
                    <Button
                      onClick={(e) => {
                        seleccionarDisponibilidad(row);
                      }}
                      variant='contained'
                      disabled={disabledProp || dataMedic.troquelSeleccionadoSC === parseInt(row.troquel)}>
                      {dataMedic.troquelSeleccionadoSC === parseInt(row.troquel) ? "Seleccionado" : "Seleccionar"}
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
        <Button onClick={onClose} variant="contained" color="primary" >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
